import { Component, Input } from '@angular/core';
import { needsPublish, neverPublished } from '../publish-state';

@Component({
  standalone: false,
  selector: 'app-publish-indicator',
  templateUrl: './publish-indicator.component.html',
})
export class PublishIndicatorComponent {
  @Input() item: any;

  needsPublish = needsPublish;

  neverPublished = neverPublished;
}
